import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
}

export default propTypes
